import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ApplyRewardCodeRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ApplyRewardCodeResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const applyRewardCode = (request: ApplyRewardCodeRequest, options?: CashRequestOptions) =>
  post<ApplyRewardCodeRequest, ApplyRewardCodeResponse>('/2.0/cash/apply-reward-code', request, {
    ...options,
    rejectOnError: true,
  })
